<template>
    <div :class="['page ch-account',{ off: !pageOn }]">
        <VHeader type="back" @back="back" />
        <div class="page-content copper" style="position: relative;">
            <img class="page-image" src="/CHLoyaltyCard.png" />
            <div class="div-btns">
                <img :src="src" style="position: absolute;width: 400px;left:15px;top:95px" />
            </div>
        </div>    
    </div>
    
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapMutations } from 'vuex'

export default {
    name: 'ch-loyalty',
    components: {
        VHeader,
    },
    mixins: [ pageOn ],
    computed: {
        customer_id () { return this.$store.state.auth._id },
        client_id () { return this.$store.state.client_id },
        customerNo () { return this.$store.state.customerNo }
    },
    watch: {
        pageOn ( pageOn ) {
            !pageOn && this.stopWatch();
        }
    },
    created () { 
        this.src = 'https://api.survey-vip.com/loyalty/'+this.customer_id+'/'+this.client_id+'?d='+Date.now();
    },
    data () {
        return {
            src: ''
        }
    },
    mounted () {
       this.startWatch();
    },
    methods: {
        startWatch () {
            WebSoc.SEND({ t: 'startLoyaltyWatch', data: { customer_id: this.customer_id, client_id: this.client_id }},resp => {
                //console.log('startLoyaltyWatch resp',resp)
                if ( resp.update ) { this.src += ('&d='+Date.now() ) }
                if ( resp.rewards ) {
                    Alert.message('You have completed '+resp.rewards+' card'+(resp.rewards > 1 ? 's' : ''),() => {
                        this.pushPage('survey');
                        this.back();
                    })
                }
            });
        },
        stopWatch () {
            WebSoc.SEND({ t: 'stopLoyaltyWatch', data: { customer_id: this.customer_id, client_id: this.client_id }},() => {
                console.log('stopped')
            })
        },
        back () {
            this.pageOn = false;
        },
        ...mapMutations(['pushPage'])
    }
}

</script>

<style>

</style>